module.exports = __webpack_public_path__ + "img/logo_whatsApp.7786eded.svg";